<template>
  <div class="article">
    <div class="title">热烈庆祝洪子晴爵士荣聘为香港一带一路研究院终身荣誉教授</div>
    <div class="info">作者：晴天集团    发布于：2024-05-21 16:26:19</div>
    <p>香港一带一路研究院（The Belt and Road Research Institute of Hong Kong，简称：bri.hk）特区政府登记号码：75216305 - 002，是香港首个专注于「一带一路」倡议的独立研究机构，于2016年1月29日设立。</p>
    <p>研究院坚持党的领导，把握正确导向，坚持围绕党和国家的中心工作，开展前瞻性、针对性、储备性的政策研究，提出专业化、建设性、切实管用的政策建议，着力提高综合研判和战略谋划能力。</p>
    <p>本院宗旨是为「一带一路」倡议的实施提供交流平台，推动香港与内地及其他「一带一路」地区的合作，以及针对国际上与「一带一路」相关的经济、金融、法律、文化和社会问题等进行研究，提出建议供政府和社会各界参考。</p>
    <p>研究院自成立以来，便吸引了国内外众多顶尖学者和业界领袖的目光。为了进一步充实研究院的人才队伍，共同为一带一路倡议贡献智慧和力量。</p>
    <p>热烈庆祝：洪子晴爵士荣聘为香港一带一路研究院终身荣誉教授</p>
    <p>洪子晴爵士在公益慈善领域的贡献是显著的，她曾获得多个奖项以肯定其在社会公益方面的努力和成果。此外，洪子晴爵士还因其卓越的商业成就和社会贡献而受到广泛认可。洪子晴爵士的人生经历也颇具传奇色彩，她在面对生活中的困难和挑战时表现出了坚韧和毅力，成为了一位成功的商业领袖和慈善家。</p>
    <p>洪子晴爵士的商业成就得到了广泛认可。作为金运佳集团、晴天集团董事局主席，她在金融行业尤其是投后管理、资产管理、市值管理及企业并购等领域表现出色。她的商业眼光也得到了市场的验证，此外，她还荣获了2022年中国十大顶级投资人的荣誉，这进一步证明了她在商业领域的领先地位。</p>
    <p>除了在商业上的成功，洪子晴爵士还是一位热心的慈善家。她在慈善公益方面的贡献同样不容小觑，获得了包括“世界杰出华人”大奖、“中国慈善家”、“亚洲十大慈善家”等在内的多项荣誉。她的慈善行为不仅帮助了需要帮助的人，也为社会树立了良好的榜样。</p>
    <p>洪子晴爵士不仅是一位成功的商业领袖，也是一位对社会有着深远影响的慈善家。她的事迹和成就为人们所敬佩，是我们学习和效仿的典范。</p>
  </div>
</template>

<script>
export default {
  name: '1',
  components: {},
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.article{
  width: 70%;
  margin: 20px auto;
  font-family: $font-family;
  .title{
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 50px;
    text-align: center;
  }

  .info{
    height: 28px;
    line-height: 28px;
    border-bottom: 1px #e8e8e8 solid;
    margin: 0;
    text-align: center;
    font-size: 0.8rem;
  }

  p{
    font-size: $content-font-size;
    color: #000000;
    line-height: 2;
    margin: 20px 0;
  }

  img{
    width: 60%;
    margin-left: 20%;
  }

  .img-alt{
    text-align: center;
  }
}

@media (max-width: 768px) {
  .article{
    width: 90%;
    margin: 20px auto;
    .title{
      font-size: 1.4rem;
      font-weight: bold;
      line-height: 50px;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $phone-content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 80%;
      margin-left: 10%;
    }

    .img-alt{
      text-align: center;
    }
  }
}

@media (max-width: 480px) {
  .article{
    width: 100vw;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 20px auto;
    .title{
      font-size: 1.4rem;
      font-weight: bold;
      line-height: 50px;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: 1rem;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 100%;
      margin: 0;
    }

    .img-alt{
      text-align: center;
    }
  }
}


</style>
